/** The western Pacific's storm names in the scripts the agencies write them
 * in — the table behind `names.ts`, kept free of the page's i18n so the
 * build (the storm pages, `web/tooling/stormpages.ts`) reads it too. See
 * `names.ts` for what each column is and where it was compiled from. */

export type NameScript = "zh" | "zh-Hant" | "ja" | "ko";

/** English key → [zh, zh-Hant, ja, ko]; null where a script has none. */
export const NAMES: Record<string, readonly [string | null, string | null, string | null, string | null]> = {
  AERE: ["艾利", "艾利", "アイレー", null],
  AMPIL: ["安比", "安比", "アンピル", "암필"],
  AMUYAO: ["阿穆丘", "阿穆丘", "アムヤオ", null],
  ATSANI: ["艾莎尼", "閃電", "アッサニー", "앗사니"],
  BAILU: ["白鹿", "白鹿", "バイルー", "바이루"],
  BANGLANG: ["班朗", "班朗", "バンラン", "방랑"],
  BANYAN: ["榕树", "榕樹", "バンヤン", null],
  BARIJAT: ["百里嘉", "百里嘉", "バリジャット", "바리자트"],
  BAVI: ["巴威", "巴威", "バービー", "바비"],
  BEBINCA: ["贝碧嘉", "貝碧佳", "バビンカ", "버빙카"],
  BOLAVEN: ["布拉万", "布拉萬", "ボラヴェン", "볼라벤"],
  BORI: ["布里", "大麥", "ボリ", null],
  BUALOI: ["博罗依", "博羅依", "ブアローイ", "부알로이"],
  BURAPHA: ["布拉帕", "布拉帕", "ブラパ", null],
  CEMPAKA: ["查帕卡", "查帕卡", "チャンパカ", null],
  CHABA: ["暹芭", "芙蓉", "チャバ", null],
  CHAMPI: ["蔷琵", "薔琵", "チャンパー", "참피"],
  CHANHOM: ["灿鸿", "昌鴻", "チャンホン", "찬홈"],
  CHANTHU: ["灿都", "璨樹", "チャンスー", null],
  CHOIWAN: ["彩云", "彩雲", "チョーイワン", "초이완"],
  CIMARON: ["西马仑", "西馬隆", "シマロン", "시마론"],
  COMAY: ["竹节草", "竹節草", "コメイ", "꼬마이"],
  DAMREY: ["达维", "丹瑞", "ダムレイ", "담레이"],
  DANAS: ["丹娜丝", "丹娜絲", "ダナス", "다나스"],
  DIANMU: ["电母", "電母", "ディアンムー", null],
  DIMSUM: ["点心", "點心", "ディムサム", null],
  DOKSURI: ["杜苏芮", "杜蘇芮", "トクスリ", "독수리"],
  DOLPHIN: ["白海豚", "白海豚", "ドルフィン", "돌핀"],
  DUJUAN: ["杜鹃", "杜鵑", "ドゥージェン", "두쥐안"],
  ETAU: ["艾涛", "艾陶", "アータウ", "아타우"],
  EWINIAR: ["艾云尼", "艾雲尼", "イーウィニャ", "에위니아"],
  FENGSHEN: ["风神", "風神", "フンシェン", "펑선"],
  FRANCISCO: ["范斯高", "范斯高", "フランシスコ", "프란시스코"],
  FUNGWONG: ["凤凰", "鳳凰", "フォンウォン", "풍웡"],
  GAEGURI: ["简古维", "青蛙", "ケグリ", null],
  GAEMI: ["格美", "凱米", "ケーミー", "개미"],
  GAENARI: ["简拉维", "簡拉維", "ケナリ", "개나리"],
  GOSARI: ["古莎莉", "古莎莉", "コザリ", null],
  GUCHOL: ["古超", "谷超", "グチョル", "구촐"],
  HAGUPIT: ["黑格比", "哈格比", "ハグピート", "하구핏"],
  HAIKUI: ["海葵", "海葵", "ハイクイ", "하이쿠이"],
  HAISHEN: ["海神", "海神", "ハイシェン", "하이선"],
  HAITANG: ["海棠", "海棠", "ハイタン", null],
  HALONG: ["夏浪", "哈隆", "ハーロン", "할롱"],
  HEBI: ["希比", "希比", "ヘビ", null],
  HIGOS: ["海高斯", "無花果", "ヒーゴス", "히고스"],
  HOABAN: ["花斑", "花斑", "ホアバン", null],
  HODU: ["核桃", "核桃", "ホードゥー", null],
  HONE: ["霍涅", "霍恩", null, null],
  INFA: ["烟花", "煙花", "インファ", "인파"],
  IONA: ["艾欧娜", "艾歐娜", null, null],
  JAMJARI: ["蜻蜓", "蜻蜓", "ツァンザリー", null],
  JANGMI: ["蔷薇", "薔蜜", "チャンミー", "장미"],
  JEBI: ["飞燕", "飛燕", "チェービー", "제비"],
  JELAWAT: ["杰拉华", "鯉魚", "ジェラワット", "즐라왓"],
  JONGDARI: ["云雀", "雲雀", "ジョンダリ", "종다리"],
  KAJIKI: ["剑鱼", "劍魚", "カジキ", "가지키"],
  KALMAEGI: ["海鸥", "海鷗", "カルマエギ", "갈매기"],
  KHANUN: ["卡努", "卡努", "カーヌン", "카눈"],
  KIROGI: ["鸿雁", "鴻雁", "キロギー", "기러기"],
  KOGUMA: ["小熊", "小熊", "コグマ", "고구마"],
  KOINU: ["小犬", "小犬", "コイヌ", "고이누"],
  KOKI: ["高基", "高基", "コキ", null],
  KONGREY: ["康妮", "康妮", "コンレイ", "콩레이"],
  KOTO: ["天琴", "天琴", "コト", "고토"],
  KRATHON: ["山陀儿", "山陀兒", "クラトーン", "끄라톤"],
  KROSA: ["罗莎", "柯羅莎", "クローサ", "크로사"],
  KROVANH: ["科罗旺", "科羅旺", "クロヴァン", "크로반"],
  KUJIRA: ["鲸鱼", "鯨魚", "クジラ", "구지라"],
  KULAP: ["玫瑰", "庫拉", "クラー", null],
  LALA: ["拉拉", "拉拉", null, null],
  LAN: ["兰恩", "蘭恩", "ラン", "란"],
  LEEPI: ["丽琵", "麗琵", "リーピ", "리피"],
  LINGLING: ["玲玲", "玲玲", "レンレン", "링링"],
  LIONROCK: ["狮子山", "獅子山", "ライオンロック", null],
  LUCBINH: ["浮莲", "布袋蓮", "ルックビン", null],
  LUPIT: ["卢碧", "盧碧", "ルピート", null],
  MALIKSI: ["马力斯", "馬力斯", "マリクシ", "말릭시"],
  MALOU: ["玛瑙", "瑪瑙", "マーロウ", null],
  MANYI: ["万宜", "萬宜", "マンニィ", "마니"],
  MARIA: ["玛莉亚", "瑪莉亞", "マリア", "마리아"],
  MATMO: ["麦德姆", "麥德姆", "マットゥモ", "마트모"],
  MAWAR: ["玛娃", "瑪娃", "マーワー", "마와르"],
  MAYSAK: ["美莎克", "梅莎", "メイサーク", "마이삭"],
  MEARI: ["米雷", "米雷", "メアリー", null],
  MEKKHALA: ["米克拉", "米克拉", "メーカラー", "메칼라"],
  MERBOK: ["苗柏", "莫柏", "マールボック", null],
  MINDULLE: ["蒲公英", "蒲公英", "ミンドゥル", null],
  MIRINAE: ["银河", "銀河", "ミリネ", null],
  MITAG: ["米娜", "米娜", "ミートク", "미탁"],
  MUIFA: ["梅花", "梅花", "ムイファー", null],
  MULAN: ["木兰", "木蘭", "ムーラン", null],
  MUN: ["木恩", "木恩", "ムーン", "문"],
  NAKRI: ["娜基莉", "娜克莉", "ナクリー", "나크리"],
  NAMTHEUN: ["南川", "南修", "ナムセーウン", null],
  NANGKA: ["浪卡", "南卡", "ナンカー", "낭카"],
  NANMADOL: ["南玛都", "南瑪都", "ナンマドル", null],
  NARAE: ["娜尼", "娜尼", "ナレ", null],
  NARI: ["百合", "百合", "ナーリー", "나리"],
  NARRA: ["紫檀", "紫檀", "ナーラ", "나라"],
  NEOGURI: ["浣熊", "浣熊", "ノグリー", "너구리"],
  NEPARTAK: ["尼伯特", "尼伯特", "ニパルタック", null],
  NESAT: ["纳沙", "尼莎", "ネサット", null],
  NIDA: ["妮妲", "妮妲", "ニーダ", null],
  NOKAEN: ["洛鞍", "洛鞍", "ノケーン", "노카엔"],
  NOLO: ["诺洛", "諾洛", null, "놀로"],
  NONGFA: ["蓝湖", "藍湖", "ノンファ", "농파"],
  NOUL: ["红霞", "紅霞", "ノウル", "노을"],
  NURI: ["鹦鹉", "鸚鵡", "ヌーリ", "누리"],
  NYATOH: ["妮亚图", "妮亞圖", "ニヤトー", null],
  OMAIS: ["奥麦斯", "奧麥斯", "オーマイス", null],
  ONGMANG: ["坡鹿", "坡鹿", "オーンマン", null],
  PABUK: ["帕布", "帕布", "パブーク", "파북"],
  PAKHAR: ["帕卡", "帕卡", "パカー", null],
  PEILOU: ["琵鹭", "琵鷺", "ペイロー", "페이러우"],
  PEIPAH: ["琵琶", "琵琶", "ペイパー", "페이파"],
  PENHA: ["西望洋", "西望洋", "ペンニャ", "페냐"],
  PODUL: ["杨柳", "楊柳", "ポードル", "버들"],
  PRAPIROON: ["派比安", "巴比侖", "プラピルーン", "프라피룬"],
  PULASAN: ["普拉桑", "葡萄桑", "プラサン", "풀라산"],
  RAGASA: ["桦加沙", "樺加沙", "ラガサ", "라가사"],
  ROKE: ["洛克", "洛克", "ロウキー", null],
  SANBA: ["三巴", "三巴", "サンバ", "산바"],
  SANVU: ["珊瑚", "珊瑚", "サンヴー", "상우"],
  SAOBIEN: ["海星", "海星", "サオビエン", null],
  SAOLA: ["苏拉", "蘇拉", "サオラー", "사올라"],
  SARBUL: ["沙布尔", "沙布爾", "ソロブル", null],
  SAUDEL: ["沙德尔", "沙德爾", "ソウデル", "사우델"],
  SENYAR: ["森亚尔", "森亞爾", null, null],
  SEPAT: ["圣帕", "聖帕", "セーパット", "스팟"],
  SHANSHAN: ["珊珊", "珊珊", "サンサン", "산산"],
  SINLAKU: ["森拉克", "辛樂克", "シンラコウ", "실라코"],
  SONCA: ["桑卡", "桑卡", "ソンカー", null],
  SONGDA: ["桑达", "桑達", "ソングダー", null],
  SONTINH: ["山神", "山神", "ソンティン", "손띤"],
  SOULIK: ["苏力", "蘇力", "ソーリック", "솔릭"],
  SURIGAE: ["舒力基", "舒力基", "スリゲ", "수리개"],
  TALAS: ["塔拉斯", "塔拉斯", "タラス", null],
  TALIM: ["泰利", "泰利", "タリム", "탈림"],
  TAPAH: ["塔巴", "塔巴", "ターファー", "타파"],
  TIANMA: ["天马", "天馬", "ティエンマ", null],
  TIROU: ["蒂鲁", "蒂魯", "ティロウ", null],
  TOKAGE: ["蝎虎", "蠍虎", "トカゲ", null],
  TOKEI: ["道玑", "時鐘", "トケイ", null],
  TOMO: ["船尾", "船尾", "トモ", null],
  TORAJI: ["桃芝", "桃芝", "トラジー", "도라지"],
  TRAMI: ["潭美", "潭美", "チャーミー", "짜미"],
  TRASES: ["翠丝", "翠絲", "トローセス", null],
  TSINGMA: ["青马", "青馬", "チンマー", null],
  USAGI: ["天兔", "天兔", "ウサギ", "우사기"],
  WIPHA: ["韦帕", "韋帕", "ウィパー", "위파"],
  WUKONG: ["悟空", "悟空", "ウーコン", "우쿵"],
  WUTIP: ["蝴蝶", "蝴蝶", "ウーティップ", "우딥"],
  YAGI: ["摩羯", "摩羯", "ヤギ", "야기"],
  YAMANEKO: ["山猫", "山貓", "ヤマネコ", null],
  YINXING: ["银杏", "銀杏", "インシン", "인싱"],
  YUNYEUNG: ["鸳鸯", "鴛鴦", "インニョン", "윈욍"],
};

const COLUMN: Record<NameScript, 0 | 1 | 2 | 3> = { zh: 0, "zh-Hant": 1, ja: 2, ko: 3 };

/** A storm's name in `script` when it is a western Pacific storm the table
 * knows, else the name as issued (null stays null). */
export function stormNameIn(name: string | null, basin: string, script: string): string | null {
  if (name === null || basin !== "WP" || !(script in COLUMN)) return name;
  return NAMES[name.toUpperCase().replace(/[^A-Z]/g, "")]?.[COLUMN[script as NameScript]] ?? name;
}
